var _isReservation, _firstName, _lastName, ref, ref1, ref2, ref3, _preferredChannelOfCommunication, _customerComment;
const fromBookAppointmentMutationToBookedAppointment = (data)=>{
    var ref7, ref4, ref5, ref6;
    return data ? {
        id: data.id,
        isReservation: (_isReservation = data.isReservation) !== null && _isReservation !== void 0 ? _isReservation : false,
        startTime: new Date(data.startTime),
        endTime: new Date(data.endTime),
        child: data.child ? {
            firstName: (_firstName = data.child.firstName) !== null && _firstName !== void 0 ? _firstName : '',
            lastName: (_lastName = data.child.lastName) !== null && _lastName !== void 0 ? _lastName : '',
            dateOfBirth: data.child.dateOfBirth ? new Date(data.child.dateOfBirth) : null
        } : undefined,
        invitee: {
            firstName: (ref = (ref7 = data.invitee) === null || ref7 === void 0 ? void 0 : ref7.firstName) !== null && ref !== void 0 ? ref : '',
            lastName: (ref1 = (ref4 = data.invitee) === null || ref4 === void 0 ? void 0 : ref4.lastName) !== null && ref1 !== void 0 ? ref1 : '',
            email: (ref2 = (ref5 = data.invitee) === null || ref5 === void 0 ? void 0 : ref5.email) !== null && ref2 !== void 0 ? ref2 : '',
            phone: (ref3 = (ref6 = data.invitee) === null || ref6 === void 0 ? void 0 : ref6.phone) !== null && ref3 !== void 0 ? ref3 : ''
        },
        preferredChannelOfCommunication: (_preferredChannelOfCommunication = data.preferredChannelOfCommunication) !== null && _preferredChannelOfCommunication !== void 0 ? _preferredChannelOfCommunication : undefined,
        customerComment: (_customerComment = data.customerComment) !== null && _customerComment !== void 0 ? _customerComment : undefined
    } : undefined;
};

export { fromBookAppointmentMutationToBookedAppointment };
//# sourceMappingURL=fromBookAppointmentMutationToBookedAppointment.js.map
